import React, { Fragment, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import {
  ShipmentFilters,
  ShipperFilter,
  RouteFilter,
  CarrierDriverFilter,
  CargoManifestFilter,
  CancelledFilter,
  HandledByFilter,
  RangeDateFilter,
  FTBFilter,
  BusinessFilter,
  BusinessFilterTenant,
} from 'components/ShipmentFilters';

import JobSelector from './JobSelector';

import { filterJobs } from 'redux/modules/jobs/effects';

import { fetchMoreJourneys } from 'redux/modules/journeys/effects';

import { getFinishedFilters } from 'redux/modules/jobs/selectors';

import { FinishedJourneyList } from 'modules/journey/list';
import { constants, getClientConfig } from 'redux/modules/client-config/selectors';

const Finished = ({ history, parentRoutes }) => {
  const { location } = history;

  const state = location.state || {};

  const { fromDetail = false } = state;

  const { action } = history;

  const filters = useSelector(getFinishedFilters);

  const dispatch = useDispatch();

  const onChangeFilter = useCallback(
    (params) => {
      dispatch(filterJobs(params, { section: 'FINISHED' }));
    },
    [dispatch]
  );

  const handleFetchMore = useCallback(
    (params) => {
      dispatch(fetchMoreJourneys(params));
    },
    [dispatch]
  );

  useEffect(() => {
    const triggerFetch = !fromDetail || action === 'POP';
    dispatch(filterJobs(filters, { triggerFetch, realtime: true, section: 'FINISHED' }));
    //eslint-disable-next-line
  }, [dispatch]);

  useEffect(() => {
    /*noop*/
  });
  const FILTERS = useSelector((state) => getClientConfig(state, constants.FILTERS));

  return (
    <Fragment>
      <ShipmentFilters
        status={filters}
        onChangeFilter={onChangeFilter}
        rows={[
          [
            <JobSelector routes={parentRoutes} />,
            <RangeDateFilter mRight="S" />,
            FILTERS[constants.JOBS_CARGO_MANIFEST] ? <CargoManifestFilter /> : <></>,
            FILTERS[constants.JOBS_CANCELLED] ? <CancelledFilter grow /> : <></>,
            <CarrierDriverFilter />,
            <ShipperFilter />,
          ],
          [
            <RouteFilter />,
            FILTERS[constants.JOBS_FTB] ? <FTBFilter /> : <></>,
            FILTERS[constants.JOBS_BUSINESS] ? <BusinessFilter marginRight /> : <></>,
            !FILTERS[constants.JOBS_BUSINESS] ? <BusinessFilterTenant marginRight /> : <></>,
            <HandledByFilter />,
          ],
        ]}
      />

      <FinishedJourneyList onLoadMore={handleFetchMore} />
    </Fragment>
  );
};

export default Finished;
